import { Calendar, ClipboardList, Inbox } from "lucide-react";
import StatusBadge from "../Program/StatusBadge";
import PrioritasBadge from "../Program/PrioritasBadge";
import RoleBadge from "../Layout/RoleBadge";
import { useState } from "react";
import TelaahStaffModal from "./TelaahStaffModal";
import { FileSearch } from "lucide-react";

function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export default function TimSaya({ subs, user, onOpenTelaah }) {

  if (subs.length === 0) {
    return (
      <div
        data-testid="tim-saya-empty"
        className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white px-6 py-16 text-center"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#e8edf2] text-[#1e3a5f]">
          <Inbox className="h-5 w-5" strokeWidth={1.8} />
        </div>
        <h3 className="mt-3 font-display text-base font-semibold text-slate-900">
          Belum ada penugasan
        </h3>
        <p className="mt-1 max-w-sm text-[12px] leading-relaxed text-slate-500">
          Saat ini belum ada sub-kegiatan yang ditugaskan untuk{" "}
          <span className="font-semibold text-slate-700">{user?.name || "Anda"}</span>.
          Penugasan akan muncul di sini setelah Irban atau Dalnis menugaskan Anda.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="tim-saya-list">
      <div className="flex items-center gap-2 text-[12px] text-slate-600">
        <ClipboardList className="h-4 w-4 text-[#1e3a5f]" />
        <span>
          Anda ditugaskan pada <b>{subs.length}</b> sub-kegiatan.
        </span>
      </div>
      {subs.map((s) => (
        <div
          key={s.id}
          data-testid={`tim-saya-item-${s.id}`}
          className="grid grid-cols-12 items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 hover:shadow-sm"
        >
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-2 text-[11px] text-slate-500">
              <span className="font-mono">{s.programKode} · {s.id}</span>
              <RoleBadge role={s.assignmentRole} />
            </div>
            <div className="mt-0.5 text-[13px] font-semibold text-slate-900">
              {s.nama}
            </div>
            <div className="mt-0.5 truncate text-[11.5px] text-slate-500" title={s.programNama}>
              Program: {s.programNama}
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="flex items-center gap-1.5 text-[11.5px] text-slate-600">
              <Calendar className="h-3 w-3 text-slate-400" />
              <span>{formatDate(s.targetMulai)}</span>
              <span className="text-slate-300">→</span>
              <span>{formatDate(s.targetSelesai)}</span>
            </div>
            <div className="mt-1">
              <PrioritasBadge prioritas={s.prioritas} />
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <StatusBadge status={s.status} />
            <div className="mt-1.5 flex items-center gap-2">
              <div className="h-1.5 w-full max-w-[100px] overflow-hidden rounded-full bg-gray-200">
                <div className="h-full bg-[#1e3a5f]" style={{ width: `${s.progress || 0}%` }} />
              </div>
              <span className="text-[10.5px] font-semibold text-slate-600">
                {s.progress || 0}%
              </span>
            </div>
            {s.id === "P11-03" ? (
              <div className="mt-3">
                <button
                  onClick={() => onOpenTelaah(s)}
                  className="inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-[#1e3a5f] bg-blue-50 px-3 py-1.5 text-[11px] font-semibold text-[#1e3a5f] hover:bg-[#1e3a5f] hover:text-white transition-colors"
                >
                  <FileSearch className="h-3.5 w-3.5" />
                  Tool Telaahan Staff
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
